import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"

interface CreateUserModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: { username: string; email: string; password: string; role: string }) => void
  isPending: boolean
}

export function CreateUserModal({ open, onOpenChange, onSubmit, isPending }: CreateUserModalProps) {
  const [username, setUsername] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [role, setRole] = useState("mediabuyer")

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    onSubmit({ username, email, password, role })
  }

  function handleOpenChange(v: boolean) {
    if (!v) {
      setUsername("")
      setEmail("")
      setPassword("")
      setRole("mediabuyer")
    }
    onOpenChange(v)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="border-[#4a4a4a] bg-[#3a3a3a] text-white">
        <DialogHeader>
          <DialogTitle>Create New User</DialogTitle>
          <DialogDescription className="text-white">
            Fill in the details to create a new user account.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">Username</label>
            <input type="text" required value={username} onChange={(e) => setUsername(e.target.value)}
              className="w-full rounded-md border border-[#555] bg-[#2d2d2d] px-3 py-2 text-white" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-[#555] bg-[#2d2d2d] px-3 py-2 text-white" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-[#555] bg-[#2d2d2d] px-3 py-2 text-white" />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Role</label>
            <select required value={role} onChange={(e) => setRole(e.target.value)}
              className="w-full rounded-md border border-[#555] bg-[#2d2d2d] px-3 py-2 text-white">
              <option value="mediabuyer">Mediabuyer</option>
              <option value="team_leader">Team Leader</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div className="flex gap-3 pt-2">
            <button type="submit" disabled={isPending}
              className="flex-1 rounded-md border border-[#8fa0ef]/35 bg-[#7488e8] px-4 py-2 font-semibold text-white shadow-sm transition-colors hover:bg-[#687bda] disabled:opacity-50">
              {isPending ? "Creating..." : "Create User"}
            </button>
            <button type="button" onClick={() => handleOpenChange(false)}
              className="flex-1 rounded-md border border-[#7a808b]/45 bg-[#636b78] px-4 py-2 font-semibold text-white shadow-sm transition-colors hover:bg-[#58606c]">
              Cancel
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
